/* eslint-disable @typescript-eslint/no-unused-vars */
import { inject } from "@angular/core";
import { CanMatchFn, Router } from "@angular/router";
import { PermissionUtil } from "../shared/utils/permission.util";

export const loginGuard: CanMatchFn = (route, segments) => {
  const router = inject(Router);
  const token = localStorage.getItem("token");

  if (token) {
    router.navigate([PermissionUtil.getLandingRoute()]);
    return false;
  }
  return true;
};
